import { getExecEndpoint } from '../../service/getExecEndpoint';
import { CrudErrorResp, CrudQueryParams } from '~/api/def/endpoints/types';
import { defaultServer } from '~/api/def/servers/defaultServer';
import { crudParametersGenerator } from '~/api/def/endpoints/crudParametersGenerator';

export const fundValuationEndpoint = {
  server: defaultServer,
  path: 'crud/fundvaluation',
  description: 'Fund Valuation CRUD',
};

const endpointFundValuationExec = getExecEndpoint<FundValuationEndpointDef>(
  fundValuationEndpoint,
);

export const endpointFundValuationGET = async (
  fields?: Partial<CrudQueryParams<keyof FundValuation>>,
) =>
  endpointFundValuationExec<'GET'>({
    method: 'GET',
    urlExtra: fields
      ? `?${crudParametersGenerator<keyof FundValuation>(fields)}`
      : undefined,
  });
export const FundValuationGuard = (
  resp: { data: FundValuation[] } | CrudErrorResp | undefined,
): resp is { data: FundValuation[] } => {
  return (
    !!resp?.hasOwnProperty('data') &&
    Array.isArray((resp as { data: FundValuation[] }).data)
  );
};
export interface FundValuationEndpointDef {
  endpoint: typeof fundValuationEndpoint;
  methods: {
    GET: {
      response: { data: FundValuation[] } | CrudErrorResp;
    };
    POST: {
      response: FundValuation | CrudErrorResp;
      payload: FundValuation;
    };
    PUT: {
      response: FundValuation | CrudErrorResp;
      payload: FundValuation;
    };
    DELETE: {
      response: undefined | CrudErrorResp;
    };
  };
}

export type FundValuation = {
  id: string;
  currentNav: number;
  valuationDate: string;
  deletedAt: string;
  createdBy: string;
  companyId: string;
  quarterEnd: string;
  grossIrr: number;
  netIrr: number;
  grossMoic: number;
  netTvpi: number;
  portfolioCompanyCount: number;
  createdAt: string;
  updatedAt: string;
  fundId: string;
  investmentFocus: string;
};
